import request from '@/utils/request'

// 角色表

let RoleApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.role/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.role/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.role/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.role/edit', data, errorback);
    },
}

export default RoleApi;



// WEBPACK FOOTER //
// ./src/api/study/role.js